import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { ficheProduitPropTypes } from "app/utils/propTypes.js";
import { QuotationPriceDetailContainer } from "app/pages/Booking/Quotation/PriceDetails/QuotationPriceDetailContainer.jsx";
import { FLIGHT_OPTIONS_STATUS, PRODUCT_PAGE_CODE_STATUS } from "app/constants";
import ContactUs from "app/pages/.shared/ContactUs/ContactUs";
import AvailablePaymentTermsContainer from "app/pages/.shared/AvailablePaymentTerms/AvailablePaymentTermsContainer";
import IconBookingAsideLoader from "app/pages/.shared/IconBookingAsideLoader";
import CondensedBookWithConfidence from "app/pages/.shared/BookWithConfidence/CondensedBookWithConfidence";
import HolidaySummaryContainer from "app/pages/Booking/HolidaySummary/HolidaySummary/HolidaySummaryContainer";
import Button from "app/pages/.shared/form/Button";
import { FormattedMessage } from "react-intl";
import IconRight from "app/pages/.shared/static/icons/IconRight";
import "./BookingAside.scss";

const BookingAside = ({
	shop,
	ficheProduit,
	showPaymentTerms,
	isQuotationPage,
	isPaymentPage,
	showContactUs,
	showPriceDetails,
	location,
	showProductPicture,
	quotation,
	enableFlexRateChoice,
}) => {
	const [, countryCode] = shop.split("-");

	const [isSubmitting, toggleSubmit] = useState(false);

	const handleCTAClick = useCallback(() => {
		document.querySelector(".quotation__button > button").click();
		if (!enableFlexRateChoice) {
			toggleSubmit(true);
		}
	}, [enableFlexRateChoice]);

	useEffect(() => {
		// reset submit state to avoid infinite loading on cta button
		toggleSubmit(false);
	}, [location.pathname]);

	const isCTALoading =
		isSubmitting ||
		quotation.status === FLIGHT_OPTIONS_STATUS.LOADING ||
		quotation.flightOptionsStatus === FLIGHT_OPTIONS_STATUS.LOADING;

	return (
		<div className="booking-aside">
			{ficheProduit.status === PRODUCT_PAGE_CODE_STATUS.SUCCESS ? (
				<div className="booking-aside__panel booking-aside__panel--my-booking">
					<HolidaySummaryContainer
						showBookingBanner
						showProductPicture={showProductPicture}
					/>
				</div>
			) : (
				<IconBookingAsideLoader />
			)}

			<div style={{ position: "sticky", top: "0" }}>
				<div className="booking-aside__panel booking-aside__panel--price-detail">
					{showPriceDetails && <QuotationPriceDetailContainer />}
					{isQuotationPage && (
						<Button
							design="primary"
							onClick={handleCTAClick}
							disabled={isCTALoading}
							loading={isCTALoading}
						>
							<FormattedMessage id="quotation.button.cta" />
							<IconRight width={16} height={16} style={{ marginLeft: 8 }} />
						</Button>
					)}
				</div>

				{showPaymentTerms && (
					<div className="booking-aside__panel booking-aside__panel--payment-terms">
						<AvailablePaymentTermsContainer isPaymentPage={isPaymentPage} />
					</div>
				)}

				{countryCode === "GB" && (
					<div className="booking-aside__atol-abta">
						<CondensedBookWithConfidence />
					</div>
				)}

				{showContactUs && (
					<div className="booking-aside__panel booking-aside__panel--contact">
						<ContactUs productReference={ficheProduit.id} />
					</div>
				)}
			</div>
		</div>
	);
};

BookingAside.propTypes = {
	shop: PropTypes.string,
	ficheProduit: ficheProduitPropTypes,
	showPaymentTerms: PropTypes.bool,
	isQuotationPage: PropTypes.bool,
	isPaymentPage: PropTypes.bool,
	showContactUs: PropTypes.bool,
	showPriceDetails: PropTypes.bool,
	quotation: PropTypes.object,
	showProductPicture: PropTypes.bool,
	enableFlexRateChoice: PropTypes.bool,
};

BookingAside.defaultProps = {
	shop: "",
	ficheProduit: {},
	location: {},
	quotation: {},
};

export default React.memo(BookingAside);
